import React from 'react';
import { Box } from '@wix/design-system';
import { ChevronDown, ChevronUp } from 'wix-ui-icons-common';
import { ActionButton } from '../../../ActionButton';
import { Collapse, useCollapse } from '../../../Collapse';
import s from './CollapsibleGrid.scss';
export const CollapsibleGrid = ({ onToggle, labels, children, dataHook, isOpen: isOpenDefault = false, }) => {
    const { isOpen, toggleCollapse } = useCollapse({ isOpen: isOpenDefault });
    const handleClick = () => {
        onToggle?.(isOpen ? 'close' : 'open');
        toggleCollapse();
    };
    if (!children) {
        // TODO: Report error? Empty
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Box, { direction: "vertical", width: "100%", className: s.collapsible, dataHook: dataHook },
        React.createElement(Collapse, { className: s.collapsible, isOpened: isOpen }, children),
        React.createElement(React.Fragment, null,
            React.createElement(Box, { verticalAlign: "middle", className: s.openCollapsibleButton },
                React.createElement(Box, { flex: 1, className: s.openCollapsibleButtonDivider }),
                React.createElement(ActionButton, { suffixIcon: isOpen ? React.createElement(ChevronUp, null) : React.createElement(ChevronDown, null), onClick: handleClick }, isOpen ? labels?.close : labels?.open),
                React.createElement(Box, { flex: 1, className: s.openCollapsibleButtonDivider })))));
};
//# sourceMappingURL=CollapsibleGrid.js.map